import Vue from 'vue'
import Router from 'vue-router'
import AnalyticalConstellationSimulation from '@/views/AnalyticalConstellation/Simulation'
import ConstellationRevisitOptimizationMission from '@/views/ConstellationRevisitOptimization/Mission'
import ConstellationRevisitOptimizationDashboard from '@/views/ConstellationRevisitOptimization/Dashboard'
import ConstellationGenerationMission from '@/views/ConstellationGeneration/GenerationMission'
import ConstellationGenerationDashboard from '@/views/ConstellationGeneration/GenerationResults'
import AnalyticalConstellationHeterogeneous from '@/views/AnalyticalConstellation/Constellation'
import AnalyticalConstellationHomogeneousGeometry from '@/views/AnalyticalConstellation/ConstellationHomogeneousGeometry'
import AnalyticalConstellationEarthMesh from '@/views/AnalyticalConstellation/EarthMesh'
import AnalyticalConstellationEarthZoneOfInterest from '@/views/AnalyticalConstellation/EarthZoneOfInterest'
import AnalyticalConstellationPayload from '@/views/AnalyticalConstellation/Payload'
import AnalyticalConstellationGroundStation from '@/views/AnalyticalConstellation/GroundStation'
import AnalyticalConstellationDashboard from '@/views/AnalyticalConstellation/Dashboard'
import DeploymentLaunch from '../views/Deployment/DeploymentLaunch'
import DeploymentMission from '../views/Deployment/DeploymentMission'
import DeploymentDashboard from '@/views/Deployment/DeploymentDashboard'
import AnalyticalOrbit from '@/views/AnalyticalModel/AnalyticalOrbit.vue'
import AnalyticalSpacecraft from '@/views/AnalyticalModel/AnalyticalSpacecraft'
import AnalyticalThruster from '@/views/AnalyticalModel/AnalyticalThruster'
import AnalyticalSensor from '@/views/AnalyticalModel/AnalyticalSensor'
import AnalyticalMagneticTorquer from '@/views/AnalyticalModel/AnalyticalMagneticTorquer'
import AnalyticalMission from '@/views/AnalyticalModel/AnalyticalMission'
import AnalyticalDashboard from '@/views/AnalyticalModel/AnalyticalDashboard'
import NumericalSpacecraft from '@/views/NumericalModel/NumericalSpacecraft'
import SpaceObject from '@/views/Defense/SpaceObject'
import CustomEvasiveScenario from '@/views/Asterx/CustomEvasiveScenario'
import ManeuverAnalysisData from '@/views/Defense/ManeuverAnalysisData'
import NumericalThruster from '@/views/NumericalModel/NumericalThruster'
import NumericalAntennaDefinition from '@/views/NumericalModel/NumericalAntennaDefinition'
import NumericalBatteryDefinition from '@/views/NumericalModel/NumericalBatteryDefinition'
import ReactionWheelDefinition from '@/views/NumericalModel/ReactionWheelDefinition'
import EarthMoonTrajectoryRequest from '@/views/BetaDevelopments/EarthMoonTrajectoryRequest'
import EarthMoonTrajectoryDashboard from '@/views/BetaDevelopments/EarthMoonTrajectoryDashboard'
import FormationFlyingSimulationRequest from '@/views/BetaDevelopments/FormationFlyingSimulationRequest'
import FormationFlyingSimulationDashboard from '@/views/BetaDevelopments/FormationFlyingSimulationDashboard'
import InspectionSimulationRequest from '@/views/BetaDevelopments/InspectionSimulationRequest'
import InspectionSimulationDashboard from '@/views/BetaDevelopments/InspectionSimulationDashboard'
import NumericalSpacecraftGeometry from '@/views/NumericalModel/NumericalSpacecraftGeometry'
import NumericalOrbit from '@/views/NumericalModel/NumericalOrbit.vue'
import NumericalMission from '@/views/NumericalModel/NumericalMission'
import NumericalSimulatorMission from '@/views/Defense/NumericalSimulatorMission'
import ManeuverRestitutionRequest from '@/views/Defense/ManeuverRestitutionRequest'
import ManeuverAnalysisRequest from '@/views/Defense/ManeuverAnalysisRequest'
import DataGeneratorRequest from '@/views/Defense/DataGeneratorRequest'
import EvasiveManeuverRequest from '@/views/Asterx/EvasiveManeuverRequest'
import ScreeningCatalogueAnalysisRequest from '@/views/Defense/ScreeningCatalogueAnalysisRequest'
import NumericalDashboard from '@/views/NumericalModel/NumericalDashboard'
import ManeuverRestitutionDashboard from '@/views/Defense/ManeuverRestitutionDashboard'
import ManeuverAnalysisDashboard from '@/views/Defense/ManeuverAnalysisDashboard'
import DataGeneratorDashboard from '@/views/Defense/DataGeneratorDashboard'
import EvasiveManeuverDashboard from '@/views/Asterx/EvasiveManeuverDashboard'
import ScreeningCatalogueAnalysisDashboard from '@/views/Defense/ScreeningCatalogueAnalysisDashboard'
import ScreeningCatalogueAnalysisReactiveDashboard from '@/views/Defense/ScreeningCatalogueAnalysisReactiveDashboard'
import SpaceObjectGroup from '@/views/Defense/SpaceObjectGroup'
import NumericalComparison from '@/views/NumericalModel/NumericalComparison'
import ConstellationComparison from '@/views/AnalyticalConstellation/ConstellationComparison'
import AnalyticalConstellationEarthPointOfInterest from '@/views/AnalyticalConstellation/AnalyticalPointOfInterest'
import NumericalConstellation from '@/views/NumericalConstellation/NumericalConstellation'
import NumericalConstellationDashboard from '@/views/NumericalConstellation/NumericalConstellationDashboard'
import CreateMission from '@/views/CreateMission'
import Mission from '@/views/Mission'
import ApplicationLayout from '@/layout/ApplicationLayout.vue'
import NotFound from '@/views/NotFoundPage.vue'
import Jail from '@/views/JailPage.vue'
import Maintenance from '@/views/MaintenancePage.vue'
import Groups from '@/views/Groups.vue'
import Processes from '@/views/Processes.vue'
import Admin from '@/views/Admin.vue'
import Pending from '@/views/Pending.vue'
import Archives from '@/views/Archives.vue'
import Conditions from '@/views/Conditions.vue'
import ThreeD from '@/components/ThreeD/ThreeD.vue'
import navigationComponents from '../components/navigationComponents.js'
import store from '../store/index'
import AbstractAlertDefinition from '@/views/Defense/AbstractAlertDefinition'
Vue.use(Router)
let URL = process.env.GUARDIAN_URL
let APP_NAME = process.env.APP_NAME

const requireAuth = async function (to, from, next) {
  const referUrl = encodeURI(window.location.origin + window.location.pathname)
  const guardianUrl = URL
  let user = store.getters.currentUser
  let authkey = to.query.authkey ? to.query.authkey : false
  let legalsAgreed = false
  let gotoConditions = false

  // If no user & no authkey: redirect Guardian
  if (!user && !authkey) {
    window.location.href = `${guardianUrl}/#/?refer=${referUrl}&from=${APP_NAME}`
  }

  // If auth key: retrieve jwt from Guardian
  if (authkey) {
    let response = await Vue.axios
      .post(`${guardianUrl}/api/key`, {
        key: authkey,
        from: APP_NAME
      })
      .catch((error) => {
        let errMessage = encodeURI(
          `Error type "${error.response.data.error.type}": ${error.response.data.error.message}`
        )
        window.location.href = `${guardianUrl}/#/?refer=${referUrl}&from=${APP_NAME}&message=${errMessage}`
      })
    await store.dispatch('login', response.data.jwt) // dispatch login to vuex + store user cookie, must be AWAIT /!\
    user = store.getters.currentUser // update local var for next
    if (user.type === 'unauthorized') {
      next('/jail')
    } else if (user.type === 'none' || user.type === 'email_not_validated') {
      next('/pending')
    } else {
      try {
        legalsAgreed = await navigationComponents.isLegalsAgreed(user) // test conditions & rgpd has been agreed
      } catch (e) {
        // if error while getting RGPD, we disconnect the user
        await store.dispatch('logout')
      }
      if (!legalsAgreed) {
        gotoConditions = true
      } else {
        next()
      }
    }
  }

  // If user logged, dispatch route
  let role = user.type
  let neededRole = to.meta.permission || [] // Empty array of permission
  if (gotoConditions && to.path !== '/conditions') {
    // Go to conditions page
    next('/conditions')
  } else {
    if (neededRole && neededRole.includes(role)) {
      next()
    } else {
      switch (role) {
        case 'admin':
          next('/missions')
          break
        case 'demo':
        case 'trial':
        case 'educational':
        case 'user':
          next('/missions')
          break
        case 'email_not_validated':
        case 'none':
          next('/pending')
          break
      }
    }
  }
}

let router = new Router({
  // TODO MFI add default path : / redirect to mission
  base: './',
  routes: [
    {
      path: '/maintenance',
      component: Maintenance
    },
    {
      path: '/jail',
      component: Jail,
      beforeEnter: requireAuth,
      meta: {
        permission: ['unauthorized']
      }
    },
    {
      path: '/admin',
      component: Admin,
      beforeEnter: requireAuth,
      meta: {
        permission: ['admin']
      }
    },
    {
      path: '/pending',
      component: Pending,
      beforeEnter: requireAuth,
      meta: {
        permission: ['email_not_validated', 'none']
      }
    },
    {
      path: '/conditions',
      component: Conditions,
      beforeEnter: requireAuth,
      meta: {
        permission: [
          'email_not_validated',
          'none',
          'demo',
          'trial',
          'educational',
          'user',
          'admin'
        ]
      }
    },
    {
      path: '/',
      component: ApplicationLayout,
      beforeEnter: requireAuth,
      children: [
        {
          path: '/analyticalmission',
          name: 'ParametricStudyRequest',
          component: AnalyticalMission,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/analyticalorbit',
          name: 'ParametricOrbitDefinition',
          component: AnalyticalOrbit,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/analyticalspacecraft',
          name: 'ParametricSpacecraftDefinition',
          component: AnalyticalSpacecraft,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/numericalconstellationmission',
          name: 'ConstellationSimulationRequest',
          component: NumericalConstellation,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/numericalconstellationdashboard',
          name: 'NumericalConstellationDashboard',
          component: NumericalConstellationDashboard,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/numericalorbit',
          name: 'OrbitDefinition',
          component: NumericalOrbit,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/numericalspacecraft',
          name: 'SpacecraftDefinition',
          component: NumericalSpacecraft,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/numericalthruster',
          name: 'PropulsionSystemDefinition',
          component: NumericalThruster,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/numericalbatterydefinition',
          name: 'BatteryDefinition',
          component: NumericalBatteryDefinition,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/reactionwheeldefinition',
          name: 'ReactionWheelDefinition',
          component: ReactionWheelDefinition,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/earthmoontrajectoryrequest',
          name: 'EarthMoonTrajectoryRequest',
          component: EarthMoonTrajectoryRequest,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/earthmoontrajectorydashboard',
          name: 'EarthMoonTrajectoryDashboard',
          component: EarthMoonTrajectoryDashboard,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/formationflyingsimulationrequest',
          name: 'FormationFlyingSimulationRequest',
          component: FormationFlyingSimulationRequest,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/formationflyingsimulationdashboard',
          name: 'FormationFlyingSimulationDashboard',
          component: FormationFlyingSimulationDashboard,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/inspectionsimulationrequest',
          name: 'InspectionSimulationRequest',
          component: InspectionSimulationRequest,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/inspectionsimulationdashboard',
          name: 'InspectionSimulationDashboard',
          component: InspectionSimulationDashboard,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/numericalantennadefinition',
          name: 'AntennaDefinition',
          component: NumericalAntennaDefinition,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/numericalspacecraftgeometry',
          name: 'SpacecraftGeometryDefinition',
          component: NumericalSpacecraftGeometry,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/numericalmission',
          name: 'SimulationRequest',
          component: NumericalMission,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/numericalsimulatormission',
          name: 'SimulatorRequest',
          component: NumericalSimulatorMission,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/maneuverrestitutionrequest',
          name: 'ManeuverRestitutionRequest',
          component: ManeuverRestitutionRequest,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/maneuverrestitutiondashboard',
          name: 'ManeuverRestitutionDashboard',
          component: ManeuverRestitutionDashboard,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/maneuveranalysisrequest',
          name: 'ManeuverAnalysisRequest',
          component: ManeuverAnalysisRequest,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/maneuveranalysisdashboard',
          name: 'ManeuverAnalysisDashboard',
          component: ManeuverAnalysisDashboard,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/spaceobject',
          name: 'SpaceObjectDefinition',
          component: SpaceObject,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/maneuveranalysisdata',
          name: 'ManeuverAnalysisData',
          component: ManeuverAnalysisData,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/datageneratorrequest',
          name: 'DataGeneratorRequest',
          component: DataGeneratorRequest,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/datageneratordashboard',
          name: 'DataGeneratorDashboard',
          component: DataGeneratorDashboard,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/evasivemaneuverrequest',
          name: 'EvasiveManeuverRequest',
          component: EvasiveManeuverRequest,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/evasivemaneuverdashboard',
          name: 'EvasiveManeuverDashboard',
          component: EvasiveManeuverDashboard,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/customevasivescenario',
          name: 'CustomEvasiveScenario',
          component: CustomEvasiveScenario,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/screeningcatalogueanalysisrequest',
          name: 'ScreeningCatalogueAnalysisRequest',
          component: ScreeningCatalogueAnalysisRequest,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/screeningcatalogueanalysisdashboard',
          name: 'ScreeningCatalogueAnalysisDashboard',
          component: ScreeningCatalogueAnalysisDashboard,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/screeningcatalogueanalysisreactivedashboard',
          name: 'ScreeningCatalogueAnalysisReactiveDashboard',
          component: ScreeningCatalogueAnalysisReactiveDashboard,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/numericaldashboard',
          name: 'NumericalDashboard',
          component: NumericalDashboard,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/numericalcomparison',
          name: 'NumericalComparison',
          component: NumericalComparison,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/constellationcomparison',
          name: 'constellationComparison',
          component: ConstellationComparison,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/numerical3d',
          name: 'Numerical3d',
          component: ThreeD,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/missions',
          name: 'Missions',
          component: Mission,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/createmission',
          name: 'CreateMission',
          component: CreateMission,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/analyticalthruster',
          name: 'ParametricPropulsionSystemDefinition',
          component: AnalyticalThruster,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/analyticalmagnetictorquer',
          name: 'ParametricMagneticTorquerDefinition',
          component: AnalyticalMagneticTorquer,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/analyticalsensor',
          name: 'ParametricSensorDefinition',
          component: AnalyticalSensor,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/analyticaldashboard',
          name: 'AnalyticalDashboard',
          component: AnalyticalDashboard,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/analyticalconstellationsimulation',
          name: 'ConstellationPerformanceAnalysisRequest',
          component: AnalyticalConstellationSimulation,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/constellationrevisitoptimizationmission',
          name: 'ConstellationOptimizationRequest',
          component: ConstellationRevisitOptimizationMission,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/constellationrevisitoptimizationdashboard',
          name: 'ConstellationRevisitOptimizationDashboard',
          component: ConstellationRevisitOptimizationDashboard,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/constellationgenerationmission',
          name: 'ConstellationGenerationRequest',
          component: ConstellationGenerationMission,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/constellationgenerationdashboard',
          name: 'ConstellationGenerationDashboard',
          component: ConstellationGenerationDashboard,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/analyticalconstellationheterogeneous',
          name: 'ConstellationDefinition',
          component: AnalyticalConstellationHeterogeneous,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/analyticalconstellationhomogeneousgeometry',
          name: 'SubConstellationDefinition',
          component: AnalyticalConstellationHomogeneousGeometry,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/analyticalconstellationearthmesh',
          name: 'EarthMeshDefinition',
          component: AnalyticalConstellationEarthMesh,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/analyticalconstellationearthpointofinterest',
          name: 'PointOfInterestDefinition',
          component: AnalyticalConstellationEarthPointOfInterest,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/analyticalconstellationearthzoneofinterest',
          name: 'ZoneOfInterestDefinition',
          component: AnalyticalConstellationEarthZoneOfInterest,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/analyticalconstellationpayload',
          name: 'PayloadDefinition',
          component: AnalyticalConstellationPayload,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/analyticalconstellationgroundstation',
          name: 'GroundStationDefinition',
          component: AnalyticalConstellationGroundStation,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/analyticalconstellationdashboard',
          name: 'AnalyticalConstellationDashboard',
          component: AnalyticalConstellationDashboard,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/deploymentdashboard',
          name: 'DeploymentDashboard',
          component: DeploymentDashboard,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/deploymentlaunch',
          name: 'LaunchDefinition',
          component: DeploymentLaunch,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/deploymentmission',
          name: 'DeploymentRequest',
          component: DeploymentMission,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/groups',
          name: 'Groups',
          component: Groups,
          beforeEnter: requireAuth,
          meta: {
            permission: ['trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/archives',
          name: 'Archives',
          component: Archives,
          beforeEnter: requireAuth,
          meta: {
            permission: ['trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/processes',
          name: 'Processes',
          component: Processes,
          beforeEnter: requireAuth,
          meta: {
            permission: ['trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/tlescreeningrequest',
          name: 'TLEScreeningRequest',
          redirect: '/screeningcatalogueanalysisreactivedashboard',
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/abstractalertdefinition',
          name: 'AbstractAlertDefinition',
          component: AbstractAlertDefinition,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        },
        {
          path: '/spaceobjectgroup',
          name: 'SpaceObjectGroup',
          component: SpaceObjectGroup,
          beforeEnter: requireAuth,
          meta: {
            permission: ['demo', 'trial', 'educational', 'user', 'admin']
          }
        }
      ]
    },
    { path: '*', component: NotFound }
  ]
})

export default router
